import React, { useMemo, useEffect, useState, useCallback } from 'react';
import { useCustomForm } from '../../hooks/useCustomForm';
import { RolePermission } from '../../types/rolePermission';
import { Role } from '../../types/roles';
import { checkIfRolePermissionExists } from '../../services/Administracion/rolePermissionService';
import { Permission } from '../../types/permission';



interface RolePermissionModalProps {
    rolePermission: RolePermission | null;
    roles: Role[];
    permissions: Permission[];
    rolePermissions: RolePermission[],
    onClose: () => void;
    onSave: (rolePermission: RolePermission) => void;
}

const RolePermissionModal: React.FC<RolePermissionModalProps> = ({
    rolePermission,
    roles,
    permissions,
    rolePermissions,
    onClose,
    onSave
}) => {

    const defaultValues = useMemo<RolePermission>(() => {
        return rolePermission || {
            role_id: 0,
            permission_id: 0,
            is_active: true,
        };
    }, [rolePermission]);

    const [rolePermissionExists, setRolePermissionExists] = useState<boolean>(false);
    //const [assignedPermissions, setAssignedPermissions] = useState<RolePermission[]>([]);


    const onSubmit = (data: RolePermission) => {
        const updated = rolePermission ? { ...rolePermission, ...data } : data;
        onSave(updated);
        console.log('Data en onSubmit: ', data);
    };

    const { register, errors, isValid, submitHandler, reset, watch } = useCustomForm<RolePermission>({
        defaultValues,
        onSubmit,
    });

    const watchedRoleId = watch('role_id');
    const watchedPermissionId = watch('permission_id');

    const checkIfExists = useCallback(async (role_id: number, permission_id: number) => {
        if (role_id && permission_id && !rolePermission) {
            try {
                const exists = await checkIfRolePermissionExists(role_id, permission_id);
                setRolePermissionExists(exists);
            } catch (error) {
                console.error('Error al verificar combinación:', error);
            }
        }
    }, [rolePermission]);

    const assignedPermissions = useMemo(() => {
        return rolePermissions
            .filter(rp => rp.role_id === watchedRoleId)
            .map(rp => {
                const permission = permissions.find(p => p.permission_id === rp.permission_id);
                return permission ? permission : null;
            })
            .filter((p): p is Permission => p !== null); // Filtra los nulos y asegura tipado
    }, [rolePermissions, permissions, watchedRoleId]);

    useEffect(() => {
        if (!rolePermission && watchedRoleId && watchedPermissionId) {
            checkIfExists(watchedRoleId, watchedPermissionId);
        }
    }, [watchedRoleId, watchedPermissionId, rolePermission, checkIfExists]);

    /*   const availablePermissions = permissions.filter(p =>
          p.is_active &&
          !assignedPermissions.some(ap => ap.permission_id === p.permission_id)
      ); */


    console.log('Roles', roles);

    useEffect(() => {
        reset(defaultValues)
    }, [rolePermission, reset, defaultValues]);

    return (
        <div className="modal show d-block" role='dialog' tabIndex={-1}>
            <div className="modal-dialog modal-dialog-centered" role='document'>
                <div className="modal-content shadow-lg bg-light">
                    <div className="modal-header">
                        <h5 className="modal-title">Asignar Permiso a Rol</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <form onSubmit={submitHandler} >
                        <div className="modal-body">
                            <div className="mb-3">
                                <label htmlFor="role_id" className='form-label'>Rol</label>
                                <select
                                    id="role_id"
                                    className={`form-select ${errors.role_id ? 'is-invalid' : ''}`}
                                    disabled={!!rolePermission}
                                    {...register('role_id', { required: 'El Rol es requerido', valueAsNumber: true })}
                                >
                                    <option value="">Seleccione un rol</option>
                                    {roles.map((r) => (
                                        r.is_active && (
                                            <option key={r.role_id} value={r.role_id}>
                                                {r.role_name}
                                            </option>
                                        )
                                    ))}
                                </select>
                                {rolePermission && (
                                    <input type="hidden" value={rolePermission.role_id} {...register('role_id')} />
                                )}
                                {errors.role_id && (
                                    <div className="invalid-feedback">{errors.role_id.message}</div>
                                )}
                            </div>
                            {/* Permisos ya asignados */}
                            {assignedPermissions.length > 0 && (
                                <div className="alert alert-info p-2">
                                    <strong>
                                        {`Permisos ya asignados a ${rolePermission
                                            ? roles.find(r => r.role_id === rolePermission?.role_id)?.role_name
                                            : roles.find(r => r.role_id === watchedRoleId)?.role_name || 'Rol no encontrado'
                                            }
                                        : `}
                                    </strong>
                                    {assignedPermissions.map(p => p.permission_name).join(', ')}
                                </div>
                            )}
                            <div className="mb-3">
                                <label htmlFor="permission_id" className='form-label'>Permiso</label>
                                <select
                                    id="permission_id"
                                    className={`form-select ${errors.permission_id ? 'is-invalid' : ''}`}
                                    disabled={!!rolePermission}
                                    {...register('permission_id', { required: 'El Permiso es requerido', valueAsNumber: true })}
                                >
                                    <option value="">Seleccione un permiso</option>
                                    {permissions.filter(p => {
                                        if (!rolePermission) {
                                            return p.is_active && !assignedPermissions.some(ap => ap.permission_id === p.permission_id);
                                        }
                                        return p.is_active;
                                    })
                                        .map(p => (
                                            <option key={p.permission_id} value={p.permission_id}>
                                                {p.permission_name}
                                            </option>
                                        ))};
                                </select>
                                {rolePermission && (
                                    <input type="hidden" value={rolePermission.permission_id} {...register('permission_id')} />
                                )}
                                {rolePermissionExists && (
                                    <div className="alert alert-warning mt-2">
                                        Esta combinación de Rol y Permiso ya existe.
                                    </div>
                                )}

                            </div>

                            <div className="form-check">
                                <input
                                    id="is_active"
                                    type="checkbox"
                                    className="form-check-input"
                                    // checked={defaultValues.is_active}
                                    {...register('is_active')}
                                />
                                <label className="form-check-label" htmlFor="is_active">Activo</label>
                            </div>
                            <div className="modal-footer">
                                <button type='button' className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                                <button
                                    type='submit'
                                    className="btn btn-primary"
                                    disabled={!isValid || rolePermissionExists}
                                >
                                    Guardar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};


export default RolePermissionModal;